export default "__VITE_ASSET__BjysZ_Rn__"